import { render } from "./cardPackage.vue?vue&type=template&id=3eae5b60&scoped=true"
import script from "./cardPackage.vue?vue&type=script&lang=js"
export * from "./cardPackage.vue?vue&type=script&lang=js"

import "./cardPackage.vue?vue&type=style&index=0&id=3eae5b60&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eae5b60"]])

export default __exports__